  <template>
  	<div class="fuzzy-matching-box">
  		<div class="fuzzy-matching-content">
  			<el-button type="text" class="textButton" @click="AddClick">新增学科</el-button>
  		</div>
  		<div class="fuzzy-matching-bottom">
  			<el-row class="list">
  				<el-table stripe :border="true"
  					:header-cell-style="{background:'#EDF6FF',color:'#000',}" ref="multipleTable" :data="tableData"
  					tooltip-effect="dark" style="width: 50%">
  					<el-table-column prop="subjectCode" label="编码">
  					</el-table-column>
  					<el-table-column prop="name" label='科目'>
  					</el-table-column>
  					<el-table-column label="操作" width="500">
  						<template #default="scope">
  							<div>
  								<el-button type="text" size="small" class="query-button" @click="reviseClick(scope.row)">修改</el-button>
  								<el-button type="text" size="small" class="shanchuBtn" @click="deleteClick(scope.row)">删除</el-button>
  							</div>
  						</template>
  					</el-table-column>
  				</el-table>
  			</el-row>
  		</div>
  	</div>
  	<Add v-if="addShow" :reviseItem="reviseItem" :titleValue="titleValue" :objLookTeacher="objLookTeacher" @backClick="backClick"></Add>
  </template>
  <script>
  	import { subjectList, subjectDelete } from '@/assets/api/schoollog';
  	import { findTeacherInfo } from '@/assets/api/renyuan';
  	import Add from './class/add.vue'
	
  	export default {
  		components: {
  			Add
  		},
  		data() {
  			return {
  				tableData: [],
				total:0,
				isSchool: false,
  				addShow: false,
  				reviseItem: {},
  				objLookTeacher: {},
  			};
  		},
  		created() {
  			this.LookTeacher()
  		},
  		mounted() {

  		},
  		methods: {
  			backClick() {
  				this.addShow = false
  				this.classAdminList()
  			},
			
  			LookTeacher() {
  				const params = {
  					userId: JSON.parse(localStorage.getItem('user')).id,
  				}
  				findTeacherInfo(params).then((res) => {
  					this.objLookTeacher = res.data.data
					if(this.objLookTeacher.schoolId != null && this.objLookTeacher.classId == null && this.objLookTeacher.gradeId == null){
						this.isSchool = true;
						this.classAdminList()
					}
  				}).catch((err) => {
  					console.log(err);
  				})
  			},
			
  			classAdminList() {
  				let params = {
  					schoolId: this.objLookTeacher.schoolId,
  				}
  				subjectList(params).then((res) => {
  					console.log(res, '列表');
  					this.tableData = res.data.data;
  				}).catch((err) => {
  					console.log(err, 444);
  				})
  			},

  			// 新增按钮
  			AddClick() {
				if(this.isSchool){
					this.titleValue = '新增科目'
					this.addShow = true
				}else{
					this.$message({
						message: '暂无权限！',
						type: 'error'
					});
				}
  			},
			
  			reviseClick(item) {
					this.titleValue = '修改科目'
  				this.addShow = true
  				this.reviseItem = item
  			},

  			//删除
  			deleteClick(item) {
				if(this.isSchool){
					this.$confirm('请确认是否删除该科目', '提示', {
							confirmButtonText: '确定',
							cancelButtonText: '取消',
							type: 'warning'
					}).then(() => {
						const params = {
							id: item.id
						}
						subjectDelete(params).then((res) => {
							this.LookTeacher()
							this.$message({
								message: '删除成功！',
								type: 'success'
							});
						})
					}).catch((err) => {
						this.$message({
							type: 'error',
							message: err.response.data.msg||'接口异常'
						});
					});
				}else{
					this.$message({
						message: '暂无权限！',
						type: 'error'
					});
				}
  			},
			
  			handleSizeChange(val) {
  				console.log(`每页 ${val} 条`);
  			},
			
  			handleCurrentChange(val) {
  				console.log(`当前页: ${val}`);
  			},
  		},
  	};
  </script>

  <style scoped lang="scss">
  	.fuzzy-matching-box {
  		padding-top: 20px;
  		// overflow: hidden;
  		overflow: auto;
  		width: 100%;
  		height: 96%;
  		background-color: #fff;
  		border-radius: 8px;

  		.textButton {
  			margin: 2px;
  			padding: 0px;
  			font-size: 15px;
  			font-weight: 700;
  		}

  		.title-top {
  			padding: 20px 20px;
  		}

  		.fuzzy-matching-top {
  			height: 130px;
  			background-color: #fff;
  			border-radius: 8px;

  			.top-first-line {
  				:deep() {
  					.el-form-item--small .el-form-item__label {
  						// background-color: red;
  						font-size: 16px;
  					}

  					.el-select--small {
  						width: 100%
  					}

  					.el-form-item--small .el-form-item__label {
  						width: 110px;
  						text-align: right;
  						height: 35px;
  						line-height: 35px;
  					}

  					.el-input {
  						width: 100%;
  						height: 35px;
  					}
  				}
  			}

  			.the-second-line {
  				margin-top: 15px;
  				position: relative;

  				.query-button {
  					position: absolute;
  					right: 300px;
  					padding: 16px 24px;
  					// top: 50%;
  					// transform: translate(0,-50%);
  				}

  			}

  			:deep() {
  				.el-range-editor--small.el-input__wrapper {
  					height: 35px;
  					line-height: 35px;
  				}
  			}

  		}

  		.fuzzy-matching-content {
  			height: 20px;
  			line-height: 20px;
  			margin-bottom: 10px;
  			font-size: 18px !important;

  			:deep() {
  				.el-button {
  					margin-left: 50px;
  					font-size: 16px;

  				}
  			}
  		}

  		.fuzzy-matching-bottom {
  			// position: absolute;
  			padding: 20px;

  			.query-button {
  				padding: 2px;
  				font-size: 15px;
  				font-weight: 700;
  			}

  			.shanchuBtn {
  				margin: 2px;
  				padding: 2px;
  				font-size: 15px;
  				font-weight: 700;
  				color: red;
  			}

  			:deep() {
  				.el-table th.el-table__cell>.cell {
  					height: 30px;
  					line-height: 30px;
  					text-align: center;
  					font-size: 16px;
  					font-weight: 700;
  				}

  				.el-table td.el-table__cell div {
  					text-align: center;
  					height: 40px;
  					line-height: 40px;
  					font-size: 16px;
  					color: black;
  				}

  				.el-table:not(.el-table--border) .el-table__cell {
  					border: 0;
  				}

  				.el-button--small {
  					font-size: 16px;
  					margin: 0;
  					padding: 10px;
  				}

  				.fuzzy-matching-box .fuzzy-matching-bottom .el-button--small {
  					font-size: 16px !important;
  				}
  			}

  			.block-fenye {
  				margin-left: 1000px;
  				margin-top: 15px;
  			}
  		}

  		.upload-box {
  			margin-top: 15px;

  			.upload-lef {
  				margin-left: 20px;
  				font-size: 14px;

  				.upload-title {}
  			}

  			.el-table tr {
  				font-size: 20px;
  			}

  			:deep() {
  				.el-table--enable-row-transition .el-table__body td.el-table__cell {
  					font-size: 40px;
  				}

  				.el-select .el-input__inner {
  					height: 35px;
  				}

  				.el-form-item--small .el-form-item__label {
  					margin-left: 20px;
  					line-height: 35px;
  				}

  				.el-upload-list {
  					// dis
  					font-size: 80px;
  				}


  			}
  		}
  	}
  </style>